import { Route, Routes } from "react-router-dom"

import { EquipmentMapLayersRouter } from "../../../modules/equipment/routers/EquipmentMapLayersRouter"
import { HorizontalSigningMapLayersRouter } from "../../../modules/horizontalSigning/routers/HorizontalSigningMapLayersRouter"
import { VerticalSigningMapLayersRouter } from "../../../modules/verticalSigning/routers/VerticalSigningMapLayersRouter"
import { MODULE_EQUIPMENT, MODULE_HORIZONTAL_SIGNING, MODULE_VERTICAL_SIGNING } from "../../constants/modules"

export const CityDesktopMapRouter = () => {

    return (
        <Routes>
            <Route
                element={
                    <VerticalSigningMapLayersRouter />
                }
                path={`/${MODULE_VERTICAL_SIGNING}/*`}
            />
            <Route
                element={<HorizontalSigningMapLayersRouter />
                }
                path={`/${MODULE_HORIZONTAL_SIGNING}/*`}
            />
            <Route
                element={
                    <EquipmentMapLayersRouter />
                }
                path={`/${MODULE_EQUIPMENT}/*`}
            />
        </Routes>
    )
}